import useBookingEditBooking from './use-booking-edit-booking';

const useBookingEditShop = (enabled: boolean = true) => {
  const query = useBookingEditBooking(enabled);

  return {
    ...query,
    data: query.data?.shop,
  };
};

export default useBookingEditShop;
